// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ProgramModelResponse {
    static getAttributeTypeMap() {
        return ProgramModelResponse.attributeTypeMap;
    }
}
ProgramModelResponse.discriminator = undefined;
ProgramModelResponse.additionalProperties = false;
ProgramModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ProgramModel"
    },
];
//# sourceMappingURL=programModelResponse.js.map